import { BackendRequestError } from "../services/utils/request";

export const enum Event {
  BackendRequestStart = "backend:request:start",
  BackendRequestEnd = "backend:request:end",
  BackendRequestSuccess = "backend:request:success",
  BackendRequestError = "backend:request:error",
}

export type RequestSuccessEvent = {
  method: string;
  message?: string | undefined;
};

export type RequestErrorEvent = {
  error: BackendRequestError;
  message?: string;
};
